import { Divider, Grid, styled, Tooltip } from "@mui/material";
import { memo, useMemo } from "react";
import { useBuildingDetailUnidContext } from "../../../../context/BuildingDetailUnidContext";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormErrorIconsMessage from "@rf-l2/form/MxFormErrorIconsMessage";
import MxFormInputField from "@rf-l2/form/text-fields/MxFormInputField";
import MxFormAutoCompleteField from "@rf-l2/form/select/MxFormAutoCompleteField";
import { A_CURRENCY, C_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import MxFormTextThousandField from "@rf-l2/form/text-fields/MxFormTextThousandField";
import translatePropertyLabels from "@rf/property/module/components/property-form/util/helps/translatePropertyLabels";
import MxTypography from "@rf-l1/MxTypography";
import { useWatchDebounced } from "@rf-hooks/useWatchDebounced";
import { useController, useWatch } from "react-hook-form";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

interface IBuildingUnitFormRendersFieldUnitProps {
  item: {
    label: string;
    icon: JSX.Element;
    show: boolean;
    field: "input" | "select" | "number" | "id" | "opt";
    name: string;
  };
}
const BuildingUnitFormRendersFieldUnit = memo(
  (props: IBuildingUnitFormRendersFieldUnitProps) => {
    const { nameUnit } = useBuildingDetailUnidContext();
    const formatLabel = (label: string) => {
      label = label.replace("units", "unidad");
      label = label.replace("building", "Conjunto");
      label = label.replace(/([0-9])/g, " $1").trim();
      label = label.replaceAll(".", " ");
      return translatePropertyLabels(label);
    };
    return (
      <Grid container item flex={1} key={props.item.label}>
        <Divider flexItem orientation="vertical" />
        <ContentUnit container flex={1}>
          <MxFormFieldController
            name={`${nameUnit}.${props.item.name}`}
            withreacthookform={1}
          >
            <Grid
              container
              gap={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item flex={1}>
                <ShowField type={props.item.field} />
              </Grid>
              <Grid item xs="auto">
                <MxFormErrorIconsMessage formatLabel={formatLabel} />
              </Grid>
            </Grid>
          </MxFormFieldController>
        </ContentUnit>
      </Grid>
    );
  }
);

export default BuildingUnitFormRendersFieldUnit;

const ContentUnit = styled(Grid)(({ theme }) => ({
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 0,
  "*": {
    border: `0px `
  }
  // "& .MuiOutlinedInput-root": {

  // }
}));

interface IField {
  type: "input" | "select" | "number" | "id" | "opt";
}
const ShowField = (props: IField) => {
  const { field: globalCurrency } = useController({
    name: CPropertyFormKeys.global_currency_property,
    defaultValue: [C_CURRENCY.RD]
  });
  const useMemoGlobalCurrency = useMemo(() => {
    return globalCurrency.value[0]?.label || C_CURRENCY.RD.label;
  }, [globalCurrency.value]);

  switch (props.type) {
    case "input":
      return <MxFormInputField />;
    case "select":
      return (
        <Tooltip title={'Este campo es determinado por la moneda general del proyecto'}>
          <MxTypography
            color="primary.main"
            fontWeight={600}
            variant="caption"
            sx={{ textTransform: "uppercase" }}
            textAlign="center"
          >
            {useMemoGlobalCurrency}
          </MxTypography>
        </Tooltip>

      );
    case "number":
      return <MxFormTextThousandField placeholder="0" />;
  }
  return <></>;
};
